import { NgModule } from '@angular/core';
import {
    CommonModule,
    CurrencyPipe,
    DecimalPipe,
    PercentPipe,
    DatePipe,
} from '@angular/common';

import { CsvService } from './services/csv.service';
import { ExcelService } from './services/excel.service';
import { CompetitorShopDataService } from '../surroundings/shops-competitors/services/shops-comp.data.service';

import {
    ApplicationInsightsService,
    UserProfileDataService,
    HttpService,
    AuthGuardService,
    SnackbarService,
    FiltersService,
    GeneralService,
} from './';
import {FilesService} from 'app/core/services/files.service';

const services = [
    ApplicationInsightsService,
    AuthGuardService,
    CompetitorShopDataService,
    CsvService,
    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    ExcelService,
    FiltersService,
    GeneralService,
    FilesService,
    HttpService,
    PercentPipe,
    SnackbarService,
    UserProfileDataService
];

@NgModule({
    imports: [CommonModule],
    providers: [...services],
})
export class CoreModule {}
